module.exports = {
	"shared.crew.original-music-composer": "Originalmusik/kompositör",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Journalist",
	"share-overlay.share": "Dela detta videoklipp",
	"shared.crew.associate-producer": "Assisterande producent",
	"shared.crew.assistant-editor": "Assisterande redaktör",
	"overlay.buy-from": "Köp från {price}",
	"shared.crew.agent": "Ombud",
	"shared.crew.additional-photography": "Extra fotograf",
	"shared.crew.sound-editor": "Ljudsättare",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Hårstylist",
	"shared.crew.makeup-effects": "Sminkeffekter",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Produktionsassistent",
	"shared.crew.executive-producer": "Exekutiv producent",
	"shared.crew.costumer": "Kostymör",
	"info-overlay.cast": "Tilldela roll",
	"shared.crew.stunt-coordinator": "Stuntregissör",
	"shared.crew.academic-advisor": "Akademisk rådgivare",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.best-boy": "Elassistent",
	"actions.purchased": "Du äger detta videoklipp",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Set Decorator",
	"shared.crew.adaptation": "Anpassning",
	"shared.crew.school-administrator": "Skolinspektör",
	"shared.crew.cable-person": "Kabelperson",
	"shared.crew.digital-effects": "Digitala effekter",
	"actions.rent": "Uthyrning",
	"info-overlay.created-by": "Av {author}",
	"social-share.twitter": "Se \"{title}\" på {siteUrl}",
	"shared.crew.production-designer": "Produktionsdesigner",
	"info-overlay.crew": "team",
	"shared.crew.producer": "Producent",
	"shared.crew.2nd-unit-dir-of-photography": "Andrateam chefsfotograf (A-foto)",
	"shared.crew.special-effects": "Specialeffekter",
	"actions.rented": "Hyrd till {date}",
	"shared.crew.boom-operator": "B-ljud",
	"shared.crew.story": "Berättelse",
	"shared.crew.script-supervisor": "Scripta",
	"shared.crew.director": "Regissör",
	"shared.crew.choreographer": "Koregraf",
	"shared.crew.production-manager": "Produktionschef",
	"quality.auto": "Automatisk",
	"shared.crew.lead-person": "Lead Person",
	"shared.crew.location-manager": "Platschef",
	"shared.crew.costume-designer": "Kostymtecknare",
	"fullscreen.exit": "Avsluta helskärmsläge",
	"shared.crew.technical-advisor": "Teknisk rådgivare",
	"shared.crew.editor": "Redigerare",
	"shared.crew.additional-grip": "Extra passare",
	"actions.buy": "Köp {price}",
	"shared.crew.assistant-camera": "Assisterande kameraman",
	"shared.crew.writer": "Skribent",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Verkställande direktör",
	"fullscreen.enter": "Helskärm",
	"shared.crew.animal-trainer": "Djurtränare",
	"shared.crew.assistant-art-director": "Assisterande reklamformgivare",
	"shared.crew.key-grip": "Chefspassare",
	"social-button.copy": "Kopiera",
	"shared.crew.makeup-artist": "Sminkös",
	"overlay.source-error": "Videoklipp kan inte spelas",
	"social-button.link": "Länk",
	"actions.buy-from": "Köp från {price}",
	"shared.crew.art-director": "Reklamformgivare",
	"shared.crew.production-coordinator": "Produktionskoordinator",
	"shared.crew.co-director": "Styrelseledamot",
	"shared.crew.co-producer": "Verkställande producent",
	"shared.crew.video-operator": "Videooperatör",
	"shared.crew.camera-operator": "Kameraman",
	"shared.crew.co-writer": "Verkställande skribent",
	"shared.crew.set-designer": "Scenograf",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Rekvisitör",
	"shared.crew.cinematographer-dp": "Filmfotograf",
	"shared.crew.grip": "Passare",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "A-ljud",
	"quality.label": "Kvalitet",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Chefselektriker",
	"shared.crew.assistant-director": "Assisterande regissör",
	"actions.subscribe": "Prenumeration {price}/månad",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animerare",
	"shared.crew.dolly-grip": "Dolly (kameravagn)",
	"shared.crew.manager": "Chef",
	"shared.crew.2nd-assistant-director": "Andre regiassistent",
	"shared.crew.author-of-adapted-material": "Författare till anpassat material"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_sv.json
// module id = 2798
// module chunks = 66